import { Plan, PlansType } from "./models/plan";

export const PLANS: Record<PlansType, Plan> = {
      free: {
            title: "free",
            description: "free_description",
            price: 0,
            recommended: false,
            active: true,
            features: {
                  maxProjects: 1,
                  maxPosts: -1,
                  maxCollaborators: 1,
                  branding: 'none',
                  metrics: 'none',
                  weeklyDigest: false,
                  reactions: false,
                  // comments: false,
                  shares: false,
                  customizations: false,
                  // customDomain: false,
                  seo: false,
                  scheduling: false,
                  // exportData: false,
                  // integrations: false,
                  subscribersNotifications: false,
                  analytics: false,
                  support: 'email',
            }
      },
      starter: {
            title: "starter",
            description: "starter_description",
            price: 29,
            recommended: true,
            active: true,
            features: {
                  maxProjects: 3,
                  maxPosts: -1,
                  maxCollaborators: 3,
                  branding: 'logoPlusColors',
                  metrics: 'viewsPlusReactions',
                  weeklyDigest: true,
                  subscribersNotifications: false,
                  reactions: true,
                  // comments: true,
                  shares: true,
                  customizations: true,
                  // customDomain: false,
                  seo: false,
                  scheduling: false,
                  // exportData: false,
                  // integrations: false,
                  analytics: false,
                  support: 'email_with_priority',
            }
      },
      pro: {
            title: "pro",
            description: "pro_description",
            price: 59,
            recommended: false,
            active: true,
            features: {
                  maxProjects: 10,
                  maxPosts: -1,
                  maxCollaborators: 5,
                  branding: 'fullCustomization',
                  metrics: 'fullMetrics',
                  weeklyDigest: true,
                  subscribersNotifications: true,
                  reactions: true,
                  // comments: true,
                  shares: true,
                  customizations: true,
                  // customDomain: true,
                  seo: true,
                  scheduling: true,
                  // exportData: true,
                  // integrations: true,
                  analytics: true,
                  support: 'email_with_priority_24h',
            }
      },
}